export const updateValidator = (value: any) => {
  const errors: any = {};

  // if (!value.uom) {
  //   errors.uom = "Required";
  // }
  // if (!value.retailPrice) {
  //   errors.retailPrice = "Required";
  // }
  // if (!value.wholeSalePrice) {
  //   errors.wholeSalePrice = "Required";
  // }

  return errors;
};

export const updateMassCommoditiesValidator = (values: any) => {
  const errors: any = {};
  if (!values.commodities || !values.commodities.length) {
    errors.commodities = { _error: "At least one member must be entered" };
  } else {
    const commoditiesError: any[] = [];
    values.commodities.forEach((commodity: any, commodityIndex: number) => {
      const commodityError: any = {};

      if (!commodity || !commodity.name) {
        commodityError.name = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.uom) {
        commodityError.uom = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.retailPrice) {
        commodityError.retailPrice = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }
    });

    if (commoditiesError.length) {
      errors.commodities = commoditiesError;
    }
  }
  return errors;
};
